module.exports = __webpack_public_path__ + "img/012-whale.6f69f960.svg";